import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'categoryCouponAdmin',
    serviceName: 'unitadmin',
    query: gql`
      query categoryCouponAdmin($ids: [String]) {
        categoryCouponAdmin(ids: $ids) {
          data {
            title
            is_active
            total_amount
            unit {
              id
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'updateCategoryCoupon',
    serviceName: 'unitadmin',
    query: gql`
      mutation updateCategoryCoupon(
        $ids: [String]!
        $title: String!
        $is_active: Int
        $unit_id: String
        $total_amount: String
      ) {
        updateCategoryCoupon(
          ids: $ids
          title: $title
          unit_id: $unit_id
          is_active: $is_active
          total_amount: $total_amount
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
